import React from 'react';

import { Col, Row } from 'reactstrap';
import { DeleteLessonFormProp } from '../../../../../types/Forms';
import { useTranslation } from 'react-i18next';
import { LessonWithRelationsToDelete } from '../../../../../types/Courses';
const FinalStepForm: React.FC<{
  deleteLesson: LessonWithRelationsToDelete;
  formData: DeleteLessonFormProp['formData'];
}> = ({ deleteLesson, formData }) => {
  const { t } = useTranslation();
  return (
    <Row className="g-3">
      <h2 className="mb-3">
        {formData.migrateToLessonId && Number(formData.migrateToLessonId) > 0
          ? t('courses.lessons.deleteLessonWizard.step3TitleMigrate', {
              lessonTitle: deleteLesson.lessonTitle,
            })
          : t('courses.lessons.deleteLessonWizard.step3TitleNoMigrate', {
              lessonTitle: deleteLesson.lessonTitle,
            })}
      </h2>
      <Col xs="12">
        {formData.migrateToLessonId ? (
          <h4>
            {t('courses.lessons.deleteLessonWizard.migrateExamsQty', {
              count: deleteLesson.totalExamsQty,
              lessonTitle: formData.migrateToLesson?.title,
            })}
          </h4>
        ) : (
          <h4>
            {t('courses.lessons.deleteLessonWizard.deleteExamsQty', {
              count: deleteLesson.totalExamsQty,
            })}
          </h4>
        )}
      </Col>
    </Row>
  );
};
export default FinalStepForm;
